import { FilterHookParams } from '../constants'
import { DatePresets, FILTER_TYPES_V2, mapDatePresents } from '../../../constants'
import { useIntl } from 'react-intl'
import dayjs from 'dayjs'

export const FILTER_SINGLE_DATE = 'singleDate'

export function parseDateFilterValueToISO(
  value: string,
  params?: { isEndOfDay?: boolean; isStartOfDay?: boolean; isUnix?: boolean; isUTC?: boolean }
) {
  const [key, start, end] = value.split(',')
  const { isEndOfDay, isStartOfDay, isUnix, isUTC } = params || {}
  if (key === DatePresets.OneMonth || key === DatePresets.OneWeek) {
    return mapDatePresents[key]
  }
  let startDate, endDate
  const dayJsFn = isUTC ? dayjs.utc : dayjs
  if (isUnix) {
    startDate = isStartOfDay ? dayjs.unix(Number(start)).startOf('day') : dayjs.unix(Number(start))
    endDate = isEndOfDay ? dayjs.unix(Number(end)).endOf('day') : dayjs.unix(Number(end))
  } else {
    startDate = isStartOfDay ? dayJsFn(start).startOf('day') : dayJsFn(start)
    endDate = isEndOfDay ? dayJsFn(end).endOf('day') : dayJsFn(end)
  }
  return {
    start: startDate.utc().toISOString(),
    end: endDate.utc().toISOString()
  }
}

const useSingleDateFilter = (params?: FilterHookParams & { presets?: string[] }) => {
  const intl = useIntl()
  return {
    title: params?.titleIntlId || 'filters.date',
    key: params?.key || FILTER_SINGLE_DATE,
    values: params?.presets ?? [],
    valuesData:
      params?.presets?.map((date) => ({
        key: date,
        name: intl.formatMessage({ id: `dateFilter.${date}` })
      })) ?? [],
    type: FILTER_TYPES_V2.dateRange
  }
}

export default useSingleDateFilter
